import { useGetClientByIdQuery, useGetNotesQuery } from '@entities/clients/rtk-query.ts';
import { useState } from 'react';

interface Params {
  search_text?: string;
}

export const useLoadNotes = (params: Params, id: number) => {
  const [page, setPage] = useState(1);

  const { data: client, isLoading: isClientLoading } = useGetClientByIdQuery(id);

  const {
    data: notesData,
    isLoading: isNotesLoading,
    isFetching: isNotesFetching,
  } = useGetNotesQuery(
    { client: client?.id as number, page, search_text: params?.search_text },
    { skip: isClientLoading || !client }
  );

  return {
    loading: isClientLoading || isNotesFetching || isNotesLoading,
    notes: notesData?.results || [],
    hasNextPage: Boolean(notesData?.next),
    loadMore: () => setPage(page + 1),
  };
};
